import { UserPropertyValue } from '@kemu-io/kemu-types';
import { posthog } from 'posthog-js';
import { useMemo } from 'react';


/**
 * @param categoryName - The category name to use for the event, e.g. 'main_menu', 'onboarding', 'account_menu', etc.
 * If provided, it will be used to prefix the event name, e.g. 'main_menu:onboarding_button_click', 'onboarding:modal_closed', etc.
 * @returns an object with a trackEvent function that can be used to track events.
 */
const useAnalyticsTracker = (categoryName?: string) => {
  
  const response = useMemo(() => {
    const trackEvent = (eventName: string, properties?: Record<string, UserPropertyValue>) => {
      if (categoryName) {
        posthog.capture(`${categoryName}:${eventName}`, properties);
      } else {
        posthog.capture(eventName, properties);
      }
    };

    return {
      /**
       * @param eventName - The event name to track, e.g. 'onboarding_button_click', 'modal_closed', etc.
       */
      trackEvent,
    };
  }, [categoryName]);

  return response;
};

export default useAnalyticsTracker;